/* eslint-disable */
import React, { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Material UI table
import { MaterialReactTable } from "material-react-table";
import { Box } from "@mui/material";

import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import { assetImages } from "constants";
import TabsHeader from "components/Common/TabsHeader/TabsHeader";
import { commonHeaderLinkLists } from "helper/PatientManagementHelper/PatientManagementHelper";
import AccessDeniedView from "components/Common/AccessDeniedView/AccessDeniedView";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import ConditionsHeader from "./Header/ConditionsHeader";
import { mergeListById } from "helper/Common/CommonHelper";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";
import DeleteWarningModal from "components/Common/Modal/DeleteWarningModal";
import AssignUserModal from "components/Common/Modal/AssignUserModal";
import MedicalCondtionFilter from "./Popup/MedicalCondtionFilter";
import AddLabelModal from "components/Common/Modal/AddLabelModal";
import { removeTagHandler } from "helper/TagHelper/TagHelper";
import SaveMedicalCondtionPopup from "components/Common/Popup/SaveMedicalCondtionPopup";

const ConditionsListBody = () => {
  const { t } = useTranslation();
  const token = localStorage.getItem("token");
  const moduleAccess = localStorage.getItem("moduleaccess");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  console.log("moduleAccess", moduleAccess);

  const [isLoading, setIsLoading] = useState(false);
  const [conditionList, setConditionList] = useState([]);
  const [rowSelection, setRowSelection] = useState({});
  const [selectedConditionIds, setSelectedConditionIds] = useState([]);
  const [selectedConditionId, setSelectedConditionId] = useState(null);
  const [selectedTagId, setSelectedTagId] = useState(null);
  const [isDataReady, setIsDataReady] = useState(false);

  // json filter query
  const [jsonFilterQuery, setJsonFilterQuery] = useState([]);
  const [isFilterReset, setIsFilterReset] = useState(false);
  const [reloadData, setReloadData] = useState(false);

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  //function for get all conditions
  const getAllConditions = async () => {
    try {
      setIsLoading(true);

      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_MEDICAL_CONDITION +
        `?token=${token}`;

      if (jsonFilterQuery.length > 0) {
        // Sanitize the jsonFilterQuery
        const sanitizedQuery = jsonFilterQuery.map((filter) => {
          if (
            (filter.operator === "includes" ||
              filter.operator === "excludes") &&
            Array.isArray(filter.value)
          ) {
            return {
              ...filter,
              value: filter.value.map((item) => item.value).join(","), // Extract and join values as a comma-separated string
            };
          }
          return filter;
        });

        requestUrl += `&filters=${JSON.stringify(sanitizedQuery)}`;
      }

      console.log("requestUrl", requestUrl);

      const response = await getData(requestUrl);

      setIsLoading(false);

      console.log("response", response);

      if (response.status) {
        setConditionList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for bulk update condition
  const updateBulkConditionHandler = async () => {
    if (selectedConditionIds.length > 0) {
      try {
        const conditionListToBeUpdate = conditionList
          .filter((item) => selectedConditionIds.includes(item._id))
          .map((item) => {
            return {
              _id: item._id,
              condition: item.condition,
              conditionname: item.conditionname,
              reportedon: item.reportedon,
              resolvedon: item.resolvedon,
              currentstatus: item.currentstatus,
            };
          });

        let conditionData = {
          medicalconditionlist: conditionListToBeUpdate,
        };

        console.log(
          "conditionData in update bulk condition handler",
          conditionData
        );

        let requestURL =
          url.API_BASE_URL +
          url.API_UPDATE_BULK_MEDICAL_CONDITION +
          `?token=${token}`;

        const response = await putData(requestURL, conditionData);

        console.log("response in update bulk condition handler", response);

        if (response.status) {
          setMessageType("success");

          setTimeout(() => {
            setSelectedConditionIds([]);
            setRowSelection({});
          }, 1500);
        } else {
          setMessageType("error");
        }

        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setAlertMessage("Please select at least one condition");
      setMessageType("error");
    }
    setShowAlert(true);
  };

  //function for delete condition
  const deleteBulkConditionHandler = async () => {
    if (selectedConditionIds.length > 0) {
      try {
        const conditionListToBeDelete = conditionList.filter((item) =>
          selectedConditionIds.includes(item._id)
        );

        let conditionData = {
          medicalconditionlist: conditionListToBeDelete,
        };

        let requestURL =
          url.API_BASE_URL +
          url.API_DELETE_BULK_MEDICAL_CONDITION +
          `?token=${token}`;

        const response = await putData(requestURL, conditionData);

        console.log(response);

        if (response.status) {
          setMessageType("success");

          setTimeout(() => {
            setConditionList((prevList) =>
              prevList.filter(
                (item) => !selectedConditionIds.includes(item._id)
              )
            );

            setSelectedConditionIds([]);
            setRowSelection({});
          }, 1500);
        } else {
          setMessageType("error");
        }

        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setAlertMessage("Please select at least one condition");
      setMessageType("error");
    }
    setShowAlert(true);
  };

  //remove tag from condition
  const removeTagFromCondition = async (tagIds, componentId) => {
    try {
      const componentUrl = url.API_ADD_REMOVE_TAG_MEDICAL_CONDITION;
      const data = await removeTagHandler(tagIds, componentId, componentUrl);

      if (data) {
        afterActionClose(data);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setTimeout(() => {
        setSelectedTagId(null);
        setSelectedConditionId(null);
      }, 1000);
    }
  };

  //function for after any action
  const afterActionClose = (data = []) => {
    setConditionList((prevList) => mergeListById(prevList, data));
  };

  const resetFilterData = () => {
    setJsonFilterQuery([]);
    setIsFilterReset(true);
    setReloadData(true);
  };

  useEffect(() => {
    if (jsonFilterQuery.length > 0) {
      getAllConditions();
      setIsDataReady(true);
    }
  }, [jsonFilterQuery]);

  useEffect(() => {
    if (reloadData) {
      getAllConditions();
      setReloadData(false);
      setIsDataReady(true);
    }
  }, [reloadData]);

  // useEffect(() => {
  //   getAllConditions();
  // }, []);

  const columns = useMemo(
    () => [
      {
        accessorKey: "#",
        header: t("Actions"),
        Cell: ({ row }) => (
          <button
            className="action_btn_mui"
            data-bs-toggle="offcanvas"
            data-bs-target="#saveMedicalConditionOffCanvas"
            aria-controls="saveMedicalConditionOffCanvas"
            onClick={() => {
              setSelectedConditionId(row.original._id);
            }}
          >
            <span className="d-block material-symbols-outlined horz_icon">
              more_horiz
            </span>
          </button>
        ),
        enableColumnActions: false, // Hides the column action icon
        enableColumnDragging: false, // Hides the move icon
        enableSorting: false,
      },
      {
        header: "Name",
        accessorKey: "condition",
        size: 200,
        Cell: ({ row }) => (
          <span>
            {row.original.conditionname && row.original.conditionname !== "" ? (
              row.original.conditionname
            ) : (
              <span style={{ color: "#bbb" }}></span>
            )}
          </span>
        ),
      },
      //tags column
      {
        accessorKey: "tagstring",
        header: t("Tags"),
        size: 200,
        Cell: ({ row }) => (
          <div className="label-wrapper py-1">
            <div className="d-flex gap-2">
              <div
                className={
                  row.original.taglist.length > 0
                    ? "label-container flex-grow-1"
                    : "d-none"
                }
              >
                <ul
                  className="d-flex flex-wrap gap-2 m-0 p-0"
                  style={{ listStyle: "none" }}
                >
                  {row.original.taglist.map((tag, index) => (
                    <li key={index} className="d-inline-flex">
                      <div className="badge d-flex align-items-center px-3 py-2 border-0 gradient-light text-black rounded-pill">
                        <span className="badge-text fs-xs fw-medium me-1">
                          {tag.title}
                        </span>
                        <Link
                          to="#"
                          className={`${
                            tag.moderator.toString() ===
                              userInfo._id.toString() ||
                            userInfo.role.slug === "ADMIN" ||
                            userInfo.role.slug === "SUPER_ADMIN"
                              ? "d-block"
                              : "d-none"
                          }`}
                          onClick={() => {
                            setSelectedConditionId(row.original._id);
                            setSelectedTagId(tag._id);
                            removeTagFromCondition([tag._id], row.original._id);
                          }}
                        >
                          {selectedTagId &&
                          selectedTagId === tag._id &&
                          selectedConditionId &&
                          selectedConditionId === row.original._id ? (
                            <div
                              className="spinner-border spinner-border-sm text-primary ms-1"
                              role="status"
                              style={{ height: "12px", width: "12px" }}
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          ) : (
                            <span
                              className="d-block text-primary material-symbols-outlined icon-sm ms-1"
                              style={{ cursor: "pointer" }}
                            >
                              cancel
                            </span>
                          )}
                        </Link>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
              <button
                className="btn btn-light btn-sm rounded-circle p-1 shadow-sm border-0 d-flex align-items-center justify-content-center mt-1"
                style={{ width: "24px", height: "24px" }}
                data-bs-toggle="modal"
                data-bs-target="#addLabelModal"
                onClick={() => setSelectedConditionIds([row.original._id])}
              >
                <span
                  className="material-symbols-outlined text-primary"
                  style={{ fontSize: "16px" }}
                >
                  add
                </span>
              </button>
            </div>
          </div>
        ),
      },
      {
        header: "Reported Date",
        accessorKey: "reportedondate",
        size: 160,
        Cell: ({ row }) => (
          <div className="joined border-bottom-0">
            <p className="d-flex align-items-center gap-2">
              <span className="d-block material-symbols-outlined icon-md">
                calendar_month
              </span>
              <span className="d-block">{row.original.reportedondate}</span>
            </p>
          </div>
        ),
      },
      {
        header: "Resolved Date",
        accessorKey: "resolvedondate",
        size: 160,
        Cell: ({ row }) => (
          <div className="joined border-bottom-0">
            <p className="d-flex align-items-center gap-2">
              <span className="d-block material-symbols-outlined icon-md">
                calendar_month
              </span>
              <span className="d-block">{row.original.resolvedondate}</span>
            </p>
          </div>
        ),
      },
      {
        header: "Current Status",
        accessorKey: "currentstatus",
        Cell: ({ row }) => (
          <span>
            {typeof row.original.currentstatus === "string" &&
            row.original.currentstatus !== "" ? (
              row.original.currentstatus
            ) : (
              <span style={{ color: "#bbb" }}></span>
            )}
          </span>
        ),
      },
      {
        header: "Assigned To",
        accessorKey: "assignedpersonname",
        Cell: ({ row }) => (
          <div
            className={
              row.original.assignedpersonname === ""
                ? "d-none"
                : "owner border-bottom-0 d-flex align-items-center gap-1"
            }
          >
            <img
              className="rounded-circle"
              height={35}
              width={35}
              src={
                row.original.assignedpersonimage == ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + row.original.assignedpersonimage
              }
              alt="Babcock"
            />
            <p>
              <span className="d-block">{row.original.assignedpersonname}</span>
            </p>
            {/* <button
                      onClick={() => {
                        createTaskChatHandler(row.original._id);
                      }}
                      className={
                        row.original.moderator.toString() === userInfo._id.toString()
                          ? "d-none"
                          : "d-flex align-items-center ms-auto border-0 bg-light"
                      }
                    >
                      <span className="d-block material-symbols-outlined icon-md text-primary">
                        chat
                      </span>
                    </button> */}
          </div>
        ),
      },
    ],
    [selectedTagId, selectedConditionId, selectedConditionIds]
  );

  //initialize the column order
  const columnOrder = [
    "#",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ]; //array of column ids (Initializing is optional as of v2.10.0)

  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key]
    );

    setSelectedConditionIds(selectedIdsArray);
  }, [rowSelection]);

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    (moduleAccess.includes("MOD_PATIENT_MANAGEMENT") &&
      moduleAccess.includes("MOD_PATIENT_CONDITION"))
  ) {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <TabsHeader
            commonHeaderObject={commonHeaderLinkLists(t)}
            activeOption={t("Conditions")}
          />
          <div className="container-fluid px-lg-5">
            <ConditionsHeader
              reloadList={resetFilterData}
              selectedItemIds={selectedConditionIds}
              updateBulkHandler={updateBulkConditionHandler}
              jsonFilterQuery={jsonFilterQuery}
            />

            {isLoading || !isDataReady ? (
              <LoadingSkeleton />
            ) : (
              <div className="table-wrapper">
                <MaterialReactTable
                  columns={columns}
                  data={conditionList}
                  enableGrouping // to enable grouping of column
                  enableRowSelection // enable showing checkbox in each row
                  getRowId={(row) => row._id}
                  onRowSelectionChange={setRowSelection}
                  state={{ rowSelection, columnOrder }}
                  initialState={{ rowSelection, columnOrder }} // to set the initial state of column order
                  defaultColumn={{
                    minSize: 20,
                    maxSize: 300,
                    size: 50, //make columns wider by default
                  }}
                  muiTableContainerProps={{
                    sx: {
                      maxHeight: "60vh",
                    },
                  }}
                  enableStickyHeader
                />
              </div>
            )}
          </div>

          {/* popup and modals */}

          <SaveMedicalCondtionPopup
            selectedConditionId={selectedConditionId}
            setSelectedConditionId={setSelectedConditionId}
            afterActionClose={afterActionClose}
            setShowAlert={setShowAlert}
            setAlertMessage={setAlertMessage}
            setMessageType={setMessageType}
          />

          <AssignUserModal
            moduleName="condition"
            afterModalClose={afterActionClose}
            selectedIds={selectedConditionIds}
            setShowAlert={setShowAlert}
            setAlertMessage={setAlertMessage}
            setMessageType={setMessageType}
            onModalClose={() => {
              setRowSelection({});
              setSelectedConditionIds([]);
            }}
          />

          <MedicalCondtionFilter
            moduleSlug="medicalcondition"
            setJsonFilterQuery={setJsonFilterQuery}
            reloadList={resetFilterData}
            isFilterReset={isFilterReset}
            setIsFilterReset={setIsFilterReset}
          />

          <AddLabelModal
            moduleName="condition"
            selectedIds={selectedConditionIds}
            afterTagModalClose={afterActionClose}
            setShowAlert={setShowAlert}
            setAlertMessage={setAlertMessage}
            setMessageType={setMessageType}
            onModalClose={() => {
              setRowSelection({});
              setSelectedConditionIds([]);
            }}
          />

          <DeleteWarningModal
            onDelete={deleteBulkConditionHandler}
            onCancelDelete={() => {
              setRowSelection({});
              setSelectedConditionIds([]);
            }}
            moduleName={t("condition")}
          />

          {showAlert && (
            <AlertNotification
              showAlert={showAlert}
              message={alertMessage}
              alertType={messageType}
              onClose={onAlertClose}
            />
          )}
        </section>
      </div>
    );
  } else {
    return <AccessDeniedView />;
  }
};

export default ConditionsListBody;
